import { AppInsights } from 'applicationinsights-js'

const instrumentationKey = process.env.APPINSIGHTS_INSTRUMENTATION_KEY

export default {
  install (Vue) {
    AppInsights.downloadAndSetup({ instrumentationKey, enableCorsCorrelation: true })
    Vue.AppInsights = this
  },
  trackPageView (pageName, pageUrl) {
    AppInsights.trackPageView(pageName, pageUrl)
  },
  trackEvent (eventName, eventProps) {
    AppInsights.trackEvent(eventName, eventProps)
  },
  setAuthenticatedUserContext (username, customerId, storeInCookie) {
    AppInsights.setAuthenticatedUserContext(username, customerId, storeInCookie)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/ApplicationInsights.js